/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import UnitEnum from 'astro/enum/unit';

import BasicAttack from 'svg/galax/unit/basic-attack';
import BasicDefence from 'svg/galax/unit/basic-defence';
import RangeAttack from 'svg/galax/unit/range-attack';
import ConeAttack from 'svg/galax/unit/cone-attack';
import AreaAttack from 'svg/galax/unit/area-attack';


import DistributionCenter from 'svg/galax/building/distribution-center';
import Garrison from 'svg/galax/building/garrison';
import Outpost from 'svg/galax/building/outpost';
import RoboticFactory from 'svg/galax/building/robotic.factory';
import Spaceport from 'svg/galax/building/spaceport';
import TransferStation from 'svg/galax/building/transfer-station';

import LaserBattery from 'svg/galax/building/laser-battery';
import GaussCannon from 'svg/galax/building/gauss-cannon';
import GaussArtillery from 'svg/galax/building/gauss-artillery';

import Shield from 'svg/galax/building/shield';
import Gate from 'svg/galax/building/gate';

import Zone from 'svg/shared/modern/zone';


export default ({ type, ...props }) =>
{
  switch (type)
  {
    case UnitEnum.Infantry:       return <BasicAttack {...props} />;
    case UnitEnum.Rangers:        return <RangeAttack {...props} />;
    case UnitEnum.SpecialForces:  return <BasicDefence {...props} />;
    case UnitEnum.AssaultTroops:  return <ConeAttack {...props} />;
    case UnitEnum.MechInfantry:   return <AreaAttack {...props} />;
    case UnitEnum.Artillery:      return <GaussCannon {...props} />;
    case UnitEnum.Outpost:        return <Outpost {...props} />;
    case UnitEnum.RocketLauncher: return <LaserBattery {...props} />;
    case UnitEnum.ShieldDome:     return <Shield {...props} />;
    case UnitEnum.Gate:           return <Gate {...props} />;
  }

  return null;
}
